module.exports = __webpack_public_path__ + "img/blog-details-5.24760b3e.jpg";